import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FiCheckCircle, FiShield, FiX, FiLoader } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { useCart } from '../context/CartContext';

const CheckoutModal = () => {
  const { isCheckingOut, setIsCheckingOut, cartTotal } = useCart();
  const [step, setStep] = useState('form'); // form, processing, success

  const handleCheckout = (e) => {
    e.preventDefault();
    setStep('processing');
    setTimeout(() => setStep('success'), 2500);
  };

  return (
    <AnimatePresence>
      {isCheckingOut && (
        <div className="fixed inset-0 z-[300] flex items-center justify-center p-4">
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={() => setIsCheckingOut(false)}
            className="absolute inset-0 bg-black/90 backdrop-blur-md"
          />
          
          <motion.div
            initial={{ scale: 0.9, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.9, opacity: 0 }}
            className="relative w-full max-w-lg glass-panel rounded-3xl overflow-hidden"
          >
            {step === 'form' && (
              <div className="p-8">
                <div className="flex justify-between items-center mb-8">
                  <h2 className="text-2xl font-black uppercase tracking-tighter">Secure Checkout</h2>
                  <button onClick={() => setIsCheckingOut(false)}><SafeIcon icon={FiX} /></button>
                </div>

                <form onSubmit={handleCheckout} className="space-y-6">
                  <div>
                    <label className="block text-[10px] font-black uppercase tracking-[0.2em] text-zinc-500 mb-2">Delivery Intelligence</label>
                    <input 
                      required
                      type="email" 
                      placeholder="EMAIL@PROTOCOL.COM"
                      className="w-full h-12 bg-white/5 border border-white/10 rounded-xl px-4 text-sm font-bold placeholder:text-zinc-700 focus:border-cyan-400 outline-none transition-colors"
                    />
                  </div>
                  
                  <div className="grid grid-cols-2 gap-4">
                    <input required placeholder="FIRST NAME" className="h-12 bg-white/5 border border-white/10 rounded-xl px-4 text-sm font-bold outline-none focus:border-cyan-400 transition-colors" />
                    <input required placeholder="LAST NAME" className="h-12 bg-white/5 border border-white/10 rounded-xl px-4 text-sm font-bold outline-none focus:border-cyan-400 transition-colors" />
                  </div>

                  <input required placeholder="SHIPPING ADDRESS" className="w-full h-12 bg-white/5 border border-white/10 rounded-xl px-4 text-sm font-bold outline-none focus:border-cyan-400 transition-colors" />

                  <div className="pt-6 border-t border-white/5">
                    <div className="flex justify-between items-center mb-6">
                      <span className="text-zinc-500 font-bold text-xs">TOTAL DUE</span>
                      <span className="text-xl font-black font-mono">${cartTotal.toFixed(2)}</span>
                    </div>
                    <button type="submit" className="w-full h-14 bg-cyan-400 text-black font-black uppercase tracking-widest text-xs hover:bg-white transition-all rounded-xl">
                      Complete Acquisition
                    </button>
                  </div>
                </form>
              </div>
            )}

            {step === 'processing' && (
              <div className="p-20 flex flex-col items-center justify-center text-center">
                <motion.div
                  animate={{ rotate: 360 }}
                  transition={{ repeat: Infinity, duration: 1, ease: 'linear' }}
                  className="mb-6"
                >
                  <SafeIcon icon={FiLoader} className="text-4xl text-cyan-400" />
                </motion.div>
                <h3 className="text-xl font-black uppercase tracking-widest mb-2">Verifying Protocol</h3>
                <p className="text-zinc-500 text-xs">Encrypting payment data and validating inventory...</p>
              </div>
            )}

            {step === 'success' && (
              <div className="p-20 flex flex-col items-center justify-center text-center">
                <motion.div
                  initial={{ scale: 0 }}
                  animate={{ scale: 1 }}
                  className="w-20 h-20 bg-fuchsia-500 rounded-full flex items-center justify-center mb-8 shadow-[0_0_30px_rgba(217,70,239,0.5)]"
                >
                  <SafeIcon icon={FiCheckCircle} className="text-4xl text-white" />
                </motion.div>
                <h3 className="text-2xl font-black uppercase tracking-tighter mb-4">Acquisition Successful</h3>
                <p className="text-zinc-400 text-sm mb-8">Your order #PX-2049 has been logged. Check your transmission inbox for details.</p>
                <button 
                  onClick={() => setIsCheckingOut(false)}
                  className="px-8 py-4 border border-white/10 hover:bg-white hover:text-black transition-all font-black uppercase tracking-widest text-[10px]"
                >
                  Return to Platform
                </button>
              </div>
            )}
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  );
};

export default CheckoutModal;